import HttpRequest from "../utils/HttpRequest.js";

var timeoutid = window.setTimeout(() => {
  //console.log("wageni", "timeout triggered");
  ping();
}, 500);

//console.log("wageni", "created timeoutid", timeoutid);

var hostname = (url) => {
  var ret = "";
  if (url) {
    var a = document.createElement('a');
    a.href = url;
    ret = a.hostname;
  }

  return ret;
};

var isPaidTraffic = function () {
  var ret = false;

  ret = window.location.href.search("[?&]gclid=") != -1;
  ret = window.location.href.search("[?&]msclkid=") != -1;

  return ret;
};

var domain = hostname(document.location.href).split('.').reverse().slice(0, 2).reverse().join(".");
var referrer = hostname(document.referrer);
referrer = referrer != domain ? referrer : "";

var source = isPaidTraffic() ? "paid" : "organic";

//get utm_source, utm_medium, utm_campaign
var _wageni = [];
if (window.wageni && window.wageni.q) {
  _wageni = window.wageni.q;
}

window.wageni = (method, props) => {
  //console.log("wageni", method, " called with ===>>>", props)
  switch (method) {
    case "ping":
      if (timeoutid) {
        window.clearTimeout(timeoutid);
        //console.log("wageni", "cleared timeoutid", timeoutid);
        timeoutid = window.setTimeout(() => {
          ping(props);
        }, 250);
      }
      break;
  }

  //console.log("wageni", "push is ready");

  //return {
  //  "push": (data) => {
  //    ping(data);
  //    console.log("wageni", "pushed", data);
  //  }
  //}
}

Object.defineProperty(window.wageni, 'push', {
  value: function (payload) {
    ping(payload);
  }
});

_wageni.forEach(w => {
  wageni(w[0], w[1]);
});

function ping(props) {
  timeoutid = null;
  var clientId = "";
  var ga_referrer = "";
  var ga_campaignName = "";
  var ga_campaignSource = "";
  var ga_campaignMedium = "";

  if (!(typeof ga === "undefined") && ga.getAll) {
    try {
      var tracker = ga.getAll()[0];

      clientId = tracker.get('clientId');
      ga_referrer = tracker.get('referrer');
      ga_campaignName = tracker.get('campaignName');
      ga_campaignSource = tracker.get('campaignSource');
      ga_campaignMedium = tracker.get('campaignMedium');
      console.log("wageni", "clientId", clientId, { ga_referrer, ga_campaignName, ga_campaignSource, ga_campaignMedium});
    } catch (error){
      console.log("wageni", "ga is not available");
    }
    //ga(function () {
    //  var tracker = ga.getAll()[0];

    //  var clientId = tracker.get('clientId');
    //} 
  }


  var payload = {
    domain: domain,
    clientId: clientId,

    location: document.location,

    referrer: referrer,
    source: source,
    current: document.location.href,
    previous: document.referrer,

    width: window.screen.width,
    userAgent: navigator.userAgent,

    ...props
  }

  //console.log("wageni!!!");
  //console.log("posting HttpRequest payload", payload);
  //console.log("wageni!!!");

  //var url = "{--wageni-host--}" + "/ping";
  var url = "/wageni/ping";

  var headers = [];
  var xhr = new HttpRequest("POST", url);//, "application/json", headers);
  return xhr.send(payload).then((response) => {
    var json = response.json;

    //if (json.message || json.exception) {
    //  alert(json.message || json.exception);
    //} else {
    //}

    console.log("wageni!!!");
    console.log("HttpRequest response", response);
    console.log("wageni!!!");

    return json;
  }).catch((e) => {
  });

  //console.log("wageni!!!");
  //console.log("posted HttpRequest payload", payload);
  //console.log("wageni!!!");

}



